<template>
  <va-card title="Insructions">
    <div class="separation-anxiety-instructions-card-content">
      <va-accordion>
        <va-collapse customHeader>
          <span slot="header">
            <va-button :outline="true" :color="$themes.primary"
              :iconRight="`fa fa-angle-down va-collapse__header__icon`">
              Exercise instructions
            </va-button>
          </span>
          <div slot="body" class="service-description">
            <ol>
              <div v-for="(info,index) in instructions" :key="index">
                <li class="question">
                  <b>{{ info.heading }}:</b> {{ info.details }}
                </li>
              </div>
            </ol>
          </div>
        </va-collapse>
      </va-accordion>
    </div>
  </va-card>
</template>

<script>
import separationAnxietyInstructions from '../../data/separation-anxiety-instructions.json'

export default {
  name: 'separation-anxiety-instructions-card',
  data () {
    return {
      instructions: separationAnxietyInstructions.instructions,
    }
  },
}
</script>

<style scoped lang="scss">
  .separation-anxiety-instructions-card-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: small;

    ol {
      margin-left: 2rem;

      li {
        list-style: number;
      }
    }
  }
</style>
